import React, { useState } from 'react';
import { motion } from 'framer-motion';
import ModalEnquiry from './ModalEnquiry';

export default function EnquireNowButton({ triggerLabel = 'Enquire Now', ...props }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="fixed z-50 flex items-center" style={{ right: '1.5rem', bottom: '1.5rem' }}>
        <motion.button
          onClick={() => setOpen(true)}
          className="fab-ring flex items-center gap-2 rounded-full px-5 py-3 shadow-lg t-sm font-medium"
          style={{ backgroundColor: 'var(--accent)', color: '#17130a' }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.97 }}
          {...props}
        >
          <span className="dot-pulse" style={{ backgroundColor: '#17130a' }} />
          {triggerLabel}
        </motion.button>
      </div>
      <ModalEnquiry open={open} onClose={() => setOpen(false)} triggerLabel={triggerLabel} />
    </>
  );
}
